// Brand assets — Joseph Poche

// Light variant: gold + cream wordmark on NAVY background — use on dark/navy surfaces
export const LOGO_LIGHT =
  "https://customer-assets.emergentagent.com/job_joseph-crm/artifacts/xcwx88o8_ChatGPT%20Image%20May%2030%2C%202026%2C%2012_25_17%20PM.png";

// Dark variant: navy + gold wordmark on CREAM background — use on light/cream surfaces
export const LOGO_DARK =
  "https://customer-assets.emergentagent.com/job_joseph-crm/artifacts/4dbpi8o5_ChatGPT%20Image%20May%2030%2C%202026%2C%2012_19_29%20PM.png";

// Backwards compatibility default (dark variant — primary asset)
export const LOGO_URL = LOGO_DARK;
